import { render, staticRenderFns } from "./shortvideo.vue?vue&type=template&id=30368410&scoped=true"
import script from "./shortvideo.vue?vue&type=script&lang=js"
export * from "./shortvideo.vue?vue&type=script&lang=js"
import style0 from "./shortvideo.vue?vue&type=style&index=0&id=30368410&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30368410",
  null
  
)

export default component.exports